import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './HeaderArticle1.css';
import React from 'react';
import { get, getDomain, pathJoin } from '../../utils';
import { Placeholder, Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import LazyPicture from '../atoms/LazyPicture';
import { fullWidthStyles } from '../57_HeaderFullWidth/headerFullWidth';
import getListing from '../../utils/getListing';
import FavouriteBtn from '../atoms/FavouriteBtn/FavouriteBtn';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { useSeoArticleScript } from '../../utils/seo';
// import RouterLink from '../atoms/RouterLink';

export var formatDate = function formatDate(date) {
  if (date) {
    var dateObj = new Date(date);
    return dateObj.toISOString();
  }
  return date;
};
var HeaderArticle1 = function HeaderArticle1(_ref) {
  var fields = _ref.fields,
    headerTypeInsights = _ref.headerTypeInsights,
    rendering = _ref.rendering,
    children = _ref.children,
    route = _ref.route,
    params = _ref.params;
  var addToFavAnalytics = get(fields || {}, 'addToFavAnalytics');
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var itemID = get(route, 'itemId', '');
  var bannerTitleName = get(route, 'name', '');
  // const itemID = "a3648f04-6051-4f08-a485-77b49c78d5cf";
  var convertedId = itemID.split('-').join('');
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    searchResults = _React$useState2[0],
    setSearchResults = _React$useState2[1];
  var currentLang = get(sitecoreContext, 'language');
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var Dictionaries = get(fields, 'Dictionaries');
  var templateName = get(route, 'templateName', '');
  ;
  var seoTitle = get(fields, 'Title');
  var seoDesc = get(fields, 'Intro Text');
  var isNewsTitle = get(fields, 'Is News Article');
  var seoType = isNewsTitle && isNewsTitle.value ? 'NewsArticle' : 'Article';
  var seoImages = get(fields, 'Fallback image');
  var datePublished = get(fields, 'Writing date');
  var dateModified = get(sitecoreContext, 'lastUpdateDate');
  var MinRead = Dictionaries && Dictionaries.find(function (item) {
    if (item && item.Key === 'MinRead') {
      return item;
    }
  });
  var script = "\n\t\t\t{\n\t\t\t\t\"@context\": \"https://schema.org\",\n\t\t\t\t\"@type\": \"".concat(seoType, "\",\n\t\t\t\t\"headline\": \"").concat(seoTitle ? seoTitle.value : '', "\",\n\t\t\t\t\"image\": [\"").concat(seoImages && seoImages.value && seoImages.value.src ? pathJoin([getDomain(), seoImages.value.src]) : '', "\"],\n\t\t\t\t\"datePublished\": \"").concat(datePublished && datePublished.value ? formatDate(datePublished.value) : '', "\",\n\t\t\t\t\"dateModified\": \"").concat(dateModified ? formatDate(dateModified) : '', "\",\n\t\t\t \"author\":\n\t\t[\n\t\t\t{\n\t\t\t\t\"@type\":\"Organization\",\n\t\t\t\t\"name\": \"Visit Dubai\",\n\t\t\t\t\"url\": \"https://www.visitdubai.com/\"\n\t\t}\n\t],\n\t\t\"publisher\": {\n\t\t\t\t\"@type\": \"Organization\",\n\t\t\t\t\"name\": \"Visit Dubai\",\n\t\t\t\t\"logo\": {\n\t\t\t\t\"@type\": \"ImageObject\",\n\t\t\t\t\"url\": \"https://www.visitdubai.com/-/media/Common/logos/logo-dubai-grey-75x29.svg?h=29&iar=0&w=75\"\n\t\t\t\t\t}\n\t\t},\n\t \"description\": \"").concat(seoDesc ? seoDesc.value : '', "\"\n\t\t\t}");
  useSeoArticleScript(script, 'article-seo-script', templateName);
  React.useEffect(function () {
    if (!headerTypeInsights) {
      var itemFilter = {
        hitsPerPage: 1,
        facetFilters: [['type:Article'], ["objectID:".concat(convertedId)]]
      };
      getListing(get(params, "SearchIndex"), itemFilter).then(function (hits) {
        setSearchResults(hits && hits.hits[0].readTime);
      });
    }
  }, []);
  if (!fields) {
    console.warn('HeaderArticle component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [HeaderArticle component is empty: please provide data source]");
    }
    return null;
  }
  var setDateFormat = function setDateFormat(date) {
    return new Date(date).toLocaleDateString(currentLang === 'en' ? 'en-GB' : currentLang, {
      weekday: 'short',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };
  var introTextObject = get(fields, 'Intro Text') || get(fields, 'pageIntro'); //pageIntro
  var introText = get(introTextObject, 'value');
  var title = get(fields, 'Title') || get(fields, 'pageTitle'); //pageTitle
  var authorObject = get(fields, 'Author', [])[0];
  var hasAuthorName = Boolean(get(authorObject, 'fields.Curator name.value')) || Boolean(get(fields, 'Author Name.value'));
  var currentAuthorName = get(authorObject, 'fields.Curator name') || get(fields, 'Author Name');
  var firstCurator = get(fields, 'fields.Curator picks') || [];
  var authorImage = get(authorObject, 'fields.Fallback image.value.src');
  var insightAuthorImage = get(fields, 'Author Image.value.src');
  var insightHeaderAuthorAlt = get(fields, 'Author Image.value.alt');
  var authorName = String(get(authorObject, 'fields.Curator name.value'));
  var hasAuthorCategory = Boolean(get(authorObject, 'fields.Curator role.value')) || Boolean(get(fields, 'Author Title.value'));
  var authorCategory = get(authorObject, 'fields.Curator role') || get(fields, 'Author Title');
  var Location = get(fields, 'Location.value') || get(fields, 'Location.fields.country.value');
  var WritingDate = get(fields, 'Writing date.value') || get(fields, 'Publication date.value') || get(fields, 'dateOfIssue.value');
  var Category = get(fields, 'Category.fields.Title.value') || get(fields, 'category.fields.fullName.value');
  var bodyCharacters = get(fields, 'Body.value.length');
  var Media = get(fields, 'Media'); // eslint-disable-line

  var renderMediaPlaceholder = function renderMediaPlaceholder() {
    return /*#__PURE__*/React.createElement(Placeholder, {
      name: "dot-media-header-article",
      rendering: rendering,
      mediaDesc: introText
    });
  };
  var renderInsightHeaderPlaceholder = function renderInsightHeaderPlaceholder() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Placeholder, {
      name: "media-header-general",
      rendering: rendering,
      mediaDesc: introText
    }));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header--article"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1 col-md-1-max-width-190"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-10"
  }, /*#__PURE__*/React.createElement("p", {
    className: "body-medium ha__localization"
  }, Category), /*#__PURE__*/React.createElement("div", {
    className: "head-content"
  }, /*#__PURE__*/React.createElement(Text, {
    className: "h1 h__title",
    tag: "h1",
    field: title
  }), /*#__PURE__*/React.createElement("div", {
    className: "ha__user--desk"
  }, !authorImage && /*#__PURE__*/React.createElement(React.Fragment, null), authorImage && /*#__PURE__*/React.createElement(LazyPicture, null, /*#__PURE__*/React.createElement("source", {
    media: "(min-width:769px)",
    srcSet: authorImage + '&cw=40&ch=40'
  }), /*#__PURE__*/React.createElement("img", {
    src: authorImage + '&cw=40&ch=40',
    alt: authorName
  })), insightAuthorImage && /*#__PURE__*/React.createElement(LazyPicture, null, /*#__PURE__*/React.createElement("source", {
    media: "(min-width:769px)",
    srcSet: insightAuthorImage + '&cw=40&ch=40'
  }), /*#__PURE__*/React.createElement("img", {
    src: insightAuthorImage + '&cw=40&ch=40',
    alt: insightHeaderAuthorAlt
  })), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, hasAuthorName && /*#__PURE__*/React.createElement(Text, {
    className: "body-medium",
    tag: "p",
    field: currentAuthorName
  }), hasAuthorCategory && /*#__PURE__*/React.createElement(Text, {
    className: "body-small user-category",
    tag: "p",
    field: authorCategory
  })))), (WritingDate || Location) && /*#__PURE__*/React.createElement("div", {
    className: "h__desc"
  }, /*#__PURE__*/React.createElement("p", {
    className: "body-medium uppercase"
  }, WritingDate && /*#__PURE__*/React.createElement(React.Fragment, null, setDateFormat(WritingDate)), Location && /*#__PURE__*/React.createElement(React.Fragment, null, ", ", Location)), searchResults && searchResults !== "0" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "body-medium h__seperator-dot"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "6",
    height: "6",
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "6",
    height: "6",
    rx: "3",
    fill: "#DDDEDE"
  }))), /*#__PURE__*/React.createElement("p", {
    className: "body-medium uppercase"
  }, searchResults, " ", MinRead && MinRead.Phrase))), /*#__PURE__*/React.createElement("div", {
    className: "ha__desc--desk"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-5"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "body-large",
    field: introTextObject
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-7 btn-like--desk"
  }, !headerTypeInsights && /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: itemID,
    classes: ' header-events__fav-btn',
    analyticsClick: function analyticsClick(action) {
      var paramsCopy = _objectSpread({}, params);
      paramsCopy.eventLab = '';
      tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, paramsCopy), "".concat(action, " : ").concat(bannerTitleName));
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-1 col-md-1-max-width-63"
  })), /*#__PURE__*/React.createElement("div", {
    className: "ha__img"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-bb__wrapper header-bb__wrapper--poster-show"
  }, !headerTypeInsights ? /*#__PURE__*/React.createElement(React.Fragment, null, process.env.STORYBOOK_MODE ? children : renderMediaPlaceholder()) : /*#__PURE__*/React.createElement(React.Fragment, null, process.env.STORYBOOK_MODE ? children : renderInsightHeaderPlaceholder()), /*#__PURE__*/React.createElement("div", {
    className: "btn-like"
  }, !headerTypeInsights && /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: itemID,
    classes: ' header-events__fav-btn',
    analyticsClick: function analyticsClick(action) {
      return tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, params), "".concat(action, " : ").concat(bannerTitleName));
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "ha__user"
  }, authorImage && /*#__PURE__*/React.createElement(LazyPicture, null, /*#__PURE__*/React.createElement("source", {
    media: "(min-width:769px)",
    srcSet: authorImage + '&cw=40&ch=40'
  }), /*#__PURE__*/React.createElement("img", {
    style: {
      width: '40px',
      height: '40px'
    },
    src: authorImage + '&cw=40&ch=40',
    alt: authorName
  })), insightAuthorImage && /*#__PURE__*/React.createElement(LazyPicture, null, /*#__PURE__*/React.createElement("source", {
    media: "(min-width:769px)",
    srcSet: insightAuthorImage + '&cw=40&ch=40'
  }), /*#__PURE__*/React.createElement("img", {
    style: {
      width: '40px',
      height: '40px'
    },
    src: insightAuthorImage + '&cw=40&ch=40',
    alt: insightHeaderAuthorAlt
  })), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, hasAuthorName && /*#__PURE__*/React.createElement(Text, {
    className: "body-medium",
    tag: "p",
    field: currentAuthorName
  }), hasAuthorCategory && /*#__PURE__*/React.createElement(Text, {
    className: "body-small user-category",
    tag: "p",
    field: authorCategory
  }))), /*#__PURE__*/React.createElement("div", {
    className: "ha__desc mobile-description"
  }, /*#__PURE__*/React.createElement("p", {
    className: "body-large"
  }, introText)))))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "remove-module-padding ".concat(commonStyles, " ").concat(fullWidthStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(headerStyle, " ").concat(headerImageStyle)
  }, children);
};
var headerStyle = "h1h6ovu9";
export var headerImageStyle = "h1vrv94s";
export var commonStyles = "c1dll4wt";
export var ltrStyles = "lrsvspa";
export var rtlStyles = "r1kp4efw";
export default HeaderArticle1;